<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('business.label.address')+$t('button.edit')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="address" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.company')">
            <vxe-input v-model="address.contactInfo.company" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.contactor')">
            <vxe-input v-model="address.contactInfo.contactor" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.phone')">
            <vxe-input v-model="address.contactInfo.phone" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.email')">
            <vxe-input v-model="address.contactInfo.email" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.idType')">
            <vxe-select v-model="address.contactInfo.idType" :options="idTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.idNumber')">
            <vxe-input v-model="address.contactInfo.idNumber" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.country')">
            <vxe-input v-model="address.addressInfo.country" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.province')">
            <vxe-input v-model="address.addressInfo.province" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.city')">
            <vxe-input v-model="address.addressInfo.city" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.district')">
            <vxe-input v-model="address.addressInfo.district" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.town')">
            <vxe-input v-model="address.addressInfo.town" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.village')">
            <vxe-input v-model="address.addressInfo.village" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.street')">
            <vxe-input v-model="address.addressInfo.street" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.postalCode')">
            <vxe-input v-model="address.addressInfo.postalCode" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.direction')">
            <vxe-select v-model="address.direction.name" :options="directions" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.detailAddress')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <vxe-textarea v-model="address.addressInfo.detailAddress" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.customer')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
            <vxe-textarea v-model="customerNames" :editable="false" style="width: 100%" @click="onCustomerSelect"/>
            <customer-modal ref="customerModal" selectType="checkbox" title="business.label.customer" @change="onCustomerChange"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Address } from '@/api/dto/common/Address'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import { getStrings } from '@/utils/util'

export default {
  name: 'AddressEditor',
  components: { CustomerModal },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      visible: false,
      loading: false,
      address: new Address(),
      customers: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 }
    }
  },
  props: {
    directions: {
      type: Array,
      default: []
    },
    idTypes: {
      type: Array,
      default: []
    }
  },
  computed: {
    customerNames() {
      return getStrings(this.customers, 'name')
    }
  },
  methods: {
    onCustomerSelect() {
      this.$refs.customerModal.open({ available: true, 'type.ordinal': 3 }, null, this.customers)
    },
    onCustomerChange(data) {
      this.customers = data
    },
    add() {
      this.visible = true
      this.address = new Address()
      this.onCustomerChange()
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('addressFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.address = new Address(res.result)
          this.onCustomerChange(res.result.customers)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const address = this.address.toJSONObject()
      address.enterprise = this.enterprise
      address.customers = this.customers.map(item => {
        return { id: item.id, name: item.name }
      })
      save('addressPersister', address).then(res => {
        if (res.success) {
          this.address = new Address()
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>